<template>
  <div class="modal contacts-success" v-if="canIShowCardDoesntFind">
    <div class="modal__content">
      <div class="modal__close" @click="showCardDoesntFind(false)"></div>
      <h3 class="modal__title">Ой!</h3>
      <div class="modal__main">
        <div class="modal__text no-drug-stores">Картку не знайдено!</div>

        <div class="modal__options">
          <a
            href="#"
            class="modal__btn modal__btn_yellow"
            @click.prevent="showCardDoesntFind(false)"
            >Ок</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
export default {
  name: "CardDoesntFind",
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["canIShowCardDoesntFind"])
  },
  methods: {
    ...mapMutations(["showCardDoesntFind"])
  }
};
</script>
